import { Box, Card, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { TreeData } from "../data";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { nurseService } from "src/api/nurse/nurseService";
// import PatientCareService from "src/api/patient-care/patientCareService";
import { useSnackbar } from 'notistack';
import ByzMuiSaveButton from "src/components/core-components/mui/buttons/ByzMuiSaveButton";

interface PatientCareEditProps {
  selectedRow: TreeData | null;
  pcsid: number;
  onClose: () => void;
  onSave: (updatedRow: any) => void;
}

function PatientCareEdit({ selectedRow, pcsid, onClose, onSave }: PatientCareEditProps) {
  const [reached, setReached] = useState(false);
  const [notReached, setNotReached] = useState(false);
  const [reachedNote, setReachedNote] = useState("");
  const [notReachedNote, setNotReachedNote] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {
    if (selectedRow) {

      const isReached = String(selectedRow.is_reached) === "1";
      const isNotReached = String(selectedRow.is_not_reached) === "1";
      setReached(isReached);
      setNotReached(isNotReached);
      // note sadece seçili olanın altına yazılacak
      if (isReached) {
        setReachedNote(selectedRow.note || "");
        setNotReachedNote("");
      } else if (isNotReached) {
        setNotReachedNote(selectedRow.note || "");
        setReachedNote("");
      } else {
        setReachedNote("");
        setNotReachedNote("");
      }
    } else {
      setReached(false);
      setNotReached(false);
      setReachedNote("");
      setNotReachedNote("");
    }
  }, [selectedRow]);

  console.log(selectedRow);
  //YATAY;443935;03042025
  const handleReachedChange = () => {
    if (!reached) {
      setReached(true);
      setNotReached(false);
    } else {
      setReached(false);
      setReachedNote("");
    }
  };

  //YATAY;443935;03042025
  const handleNotReachedChange = () => {
    if (!notReached) {
      setNotReached(true);
      setReached(false);
    } else {
      setNotReached(false);
      setNotReachedNote("");
    }
  };

  // Api Geldiğinde Açılacak
  //   const [name, setName] = useState("");
  //   const [position, setPosition] = useState("");
  //   const [treatment, setTreatment] = useState("");  
  //   const [treatment, setProcessTime] = useState("");   
  //   const [processor, setprocessor] = useState("");  
  //   const [note, setnote] = useState("");  
  //   const [status1, setStatus1] = useState(false);
  //   const [status2, setStatus2] = useState(false);

  //   useEffect(() => {
  //     const fetchData = async () => {
  //       if (pcsid) { 
  //         try {
  //           const data = await PatientCareService.listId(pcsid); // API'den veri çek
  //           if (data) {
  //             setName(data.name);
  //             setStatus1(data.status1 === "Ulaşıldı");
  //             setStatus2(data.status2 === "Ulaşılmadı");
  //           }
  //         } catch (error) {
  //           console.error("Veri çekme hatası:", error);
  //         }
  //       }
  //     };

  //     fetchData();
  //   }, [pcsid]); 

  const handleSave = async () => {
    if (!selectedRow || isSaving) return;
    setIsSaving(true);
    const now = new Date().toISOString();
    const payload = {
      id: selectedRow.id,
      note: reached ? reachedNote : notReached ? notReachedNote : "",
      isReached: reached ? "1" : "0",
      isNotReached: notReached ? "1" : "0",
      processtime: now,
    };
    try {
      await nurseService.patientNurseCarePlan.updatePatientNurseCarePlan(payload);
      enqueueSnackbar(t("messages.update-success"), { variant: "success" });
      if (onSave) onSave({
        ...selectedRow,
        note: payload.note.trim(),
        is_reached: reached ? "1" : "0",
        is_not_reached: notReached ? "1" : "0",
        processtime: now,
      });
      if (onClose) onClose();
    } catch (error) {
      enqueueSnackbar(t("messages.update-error"), { variant: "error" });
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };
  const { t } = useTranslate();

  return (
    <Box>
      <Grid sx={{ margin: "2px", p: 1, borderBottom: "1px solid black" }}>
        <ByzMuiSaveButton
          onClick={handleSave}
          loading={isSaving}
          disabled={isSaving}
          popup={false}
        />
      </Grid>

      {/* YATAY;443935;03042025;TALEPTEKI TASARIMA GORE KODDA DEGISIKLIKLER YAPILDI  */}
      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container spacing={2} alignItems="stretch" sx={{ height: "100%" }}>
          <Grid item xs={7} marginTop={1} sx={{ bgcolor: "#F4F7FE" }} >
            <ByzMuiTypography variant="subtitle1">
              {t("patient-care-guide.guidename")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <ByzMuiTextField
              label={t("patient-care-guide.guidename")}
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              margin="normal"
              disabled={true}
              value={selectedRow?.name || ""}
              onChange={(e) => console.log(e.target.value)}
            />
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.reached")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={reached} onChange={handleReachedChange} />
              {/*Api Geldiğinde Açılacak*/}
              {/* <FormControlLabel
                            control={<ByzMuiCheckBox checked={reached} onChange={() => setReached(!reached)} />}
                            label="" // Label'ı boş bırakıyoruz
                          /> */}
            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!reached}
                value={reached ? reachedNote : ""}
                onChange={(e) => setReachedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.notreached")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={notReached} onChange={handleNotReachedChange} />
              {/*Api Geldiğinde Açılacak*/}
              {/* <FormControlLabel
                            control={<ByzMuiCheckBox checked={notReached} onChange={() => setReached(!notReached)} />}
                            label="" // Label'ı boş bırakıyoruz
                          /> */}
            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!notReached}
                value={notReached ? notReachedNote : ""}
                onChange={(e) => setNotReachedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}

export default PatientCareEdit;
